export default [
  {
    id: 1,
    from: "Dallas",
    to: "New York",
    score: 11
  },
  {
    id: 2,
    from: "Denver",
    to: "Pittsburgh",
    score: 11
  },
  {
    id: 3,
    from: "Duluth",
    to: "Houston",
    score: 8
  },
  {
    id: 4,
    from: "Winnipeg",
    to: "Little Rock",
    score: 11
  },
  {
    id: 5,
    from: "Sault St.Marie",
    to: "Oklahoma City",
    score: 8
  },
  {
    id: 6,
    from: "Toronto",
    to: "Charleston",
    score: 6
  },
  {
    id: 7,
    from: "Calgary",
    to: "Salt Lake City",
    score: 7
  },
  {
    id: 8,
    from: "Chicago",
    to: "Santa Fe",
    score: 9
  },
  {
    id: 9,
    from: "Vancouver",
    to: "Montreal",
    score: 20
  },
  {
    id: 10,
    from: "Duluth",
    to: "El Paso",
    score: 10
  },
  {
    id: 11,
    from: "Duluth",
    to: "Dallas",
    score: 7
  },
  {
    id: 12,
    from: "Kansas City",
    to: "Boston",
    score: 11
  },
  {
    id: 13,
    from: "Seattle",
    to: "Las Vegas",
    score: 10
  },
  {
    id: 14,
    from: "Portland",
    to: "Nashville",
    score: 17
  },
  {
    id: 15,
    from: "Portland",
    to: "Phoenix",
    score: 11
  },
  {
    id: 16,
    from: "Los Angeles",
    to: "Calgary",
    score: 12
  },
  {
    id: 17,
    from: "Montreal",
    to: "Chicago",
    score: 7
  },
  {
    id: 18,
    from: "Helena",
    to: "Los Angeles",
    score: 8
  },
  {
    id: 19,
    from: "New York",
    to: "Miami",
    score: 10
  },
  {
    id: 20,
    from: "Seattle",
    to: "Los Angeles",
    score: 9
  },
  {
    id: 21,
    from: "Washington",
    to: "Atlanta",
    score: 4
  },
  {
    id: 22,
    from: "Winnipeg",
    to: "Omaha",
    score: 6
  },
  {
    id: 23,
    from: "Portland",
    to: "Houston",
    score: 16
  },
  {
    id: 24,
    from: "Houston",
    to: "Washington",
    score: 10
  },
  {
    id: 25,
    from: "Montreal",
    to: "New Orleans",
    score: 13
  },
  {
    id: 26,
    from: "Los Angeles",
    to: "New York",
    score: 20
  },
  {
    id: 27,
    from: "Phoenix",
    to: "Boston",
    score: 19
  },
  {
    id: 28,
    from: "Chicago",
    to: "Atlanta",
    score: 5
  },
  {
    id: 29,
    from: "Los Angeles",
    to: "Atlanta",
    score: 15
  },
  {
    id: 30,
    from: "Salt Lake City",
    to: "Kansas City",
    score: 7
  },
  {
    id: 31,
    from: "Chicago",
    to: "New Orleans",
    score: 7
  },
  {
    id: 32,
    from: "Pittsburgh",
    to: "New Orleans",
    score: 8
  },
  {
    id: 33,
    from: "Sault St.Marie",
    to: "Nashville",
    score: 8
  },
  {
    id: 34,
    from: "Montreal",
    to: "Atlanta",
    score: 9
  },
  {
    id: 35,
    from: "Toronto",
    to: "Miami",
    score: 10
  },
  {
    id: 36,
    from: "Saint Louis",
    to: "Miami",
    score: 8
  },
  {
    id: 37,
    from: "Winnipeg",
    to: "Santa Fe",
    score: 10
  },
  {
    id: 38,
    from: "Sault St.Marie",
    to: "Miami",
    score: 12
  },
  {
    id: 39,
    from: "Boston",
    to: "Miami",
    score: 12
  },
  {
    id: 40,
    from: "Seattle",
    to: "Oklahoma City",
    score: 14
  },
  {
    id: 41,
    from: "Nashville",
    to: "New York",
    score: 6
  },
  {
    id: 42,
    from: "Chicago",
    to: "New York",
    score: 5
  },
  {
    id: 43,
    from: "Denver",
    to: "El Paso",
    score: 4
  },
  {
    id: 44,
    from: "Las Vegas",
    to: "New York",
    score: 19
  },
  {
    id: 45,
    from: "Salt Lake City",
    to: "Chicago",
    score: 11
  },
  {
    id: 46,
    from: "Kansas City",
    to: "Houston",
    score: 5
  },
  {
    id: 47,
    from: "San Francisco",
    to: "Washington",
    score: 21
  },
  {
    id: 48,
    from: "San Francisco",
    to: "Sault St.Marie",
    score: 17
  },
  {
    id: 49,
    from: "Boston",
    to: "Washington",
    score: 4
  },
  {
    id: 50,
    from: "Los Angeles",
    to: "Miami",
    score: 19
  },
  {
    id: 51,
    from: "Denver",
    to: "Saint Louis",
    score: 6
  },
  {
    id: 52,
    from: "Vancouver",
    to: "Santa Fe",
    score: 13
  },
  {
    id: 53,
    from: "Las Vegas",
    to: "Miami",
    score: 21
  },
  {
    id: 54,
    from: "Winnipeg",
    to: "Houston",
    score: 12
  },
  {
    id: 55,
    from: "Vancouver",
    to: "Portland",
    score: 2
  },
  {
    id: 56,
    from: "Montreal",
    to: "Dallas",
    score: 13
  },
  {
    id: 57,
    from: "Calgary",
    to: "Phoenix",
    score: 13
  },
  {
    id: 58,
    from: "Seattle",
    to: "New York",
    score: 20
  },
  {
    id: 59,
    from: "Los Angeles",
    to: "Oklahoma City",
    score: 9
  },
  {
    id: 60,
    from: "Portland",
    to: "Pittsburgh",
    score: 19
  },
  {
    id: 61,
    from: "San Francisco",
    to: "Atlanta",
    score: 17
  },
  {
    id: 62,
    from: "Los Angeles",
    to: "Chicago",
    score: 16
  },
  {
    id: 63,
    from: "Omaha",
    to: "New Orleans",
    score: 8
  },
  {
    id: 64,
    from: "Calgary",
    to: "Nashville",
    score: 14
  },
  {
    id: 65,
    from: "New York",
    to: "Atlanta",
    score: 6
  },
  {
    id: 66,
    from: "Chicago",
    to: "Boston",
    score: 7
  },
  {
    id: 67,
    from: "Montreal",
    to: "Raleigh",
    score: 7
  },
  {
    id: 68,
    from: "Vancouver",
    to: "Duluth",
    score: 13
  },
  {
    id: 69,
    from: "Vancouver",
    to: "Denver",
    score: 11
  }
];
